document.addEventListener("DOMContentLoaded", function () {

  var redirectLink = document.querySelector('#js-timeout-layout');

  if (redirectLink) {
    let seconds = 5;
    let counter = null;
    const path = redirectLink.dataset.path;

    const updateCounter = function() {
      seconds--;

      if (seconds == 0) {
        clearInterval(counter);
        window.location = path;
      }
    }

    counter = setInterval(updateCounter, 1000)
  }
});
